module.exports = __webpack_public_path__ + "static/img/pico46.3710153.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pico46.png
// module id = ux3Q
// module chunks = 0